export default __webpack_public_path__ + "static/media/transfer_navicon-light.f87d3716.svg";